var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.752 6.918c-3.293 1.895-4.627 5.081-4.627 5.081s2.702 6.453 9.906 6.453c2.023 0 3.691-.509 5.044-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.937 12s-2.702 6.453-9.906 6.453S2.125 12 2.125 12s2.702-6.453 9.906-6.453S21.936 12 21.936 12z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.031,
    cy: 12,
    r: 3.5
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PGcgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiI+PHBhdGggZD0iTTYuNzUyIDYuOTE4Yy0zLjI5MyAxLjg5NS00LjYyNyA1LjA4MS00LjYyNyA1LjA4MXMyLjcwMiA2LjQ1MyA5LjkwNiA2LjQ1M2MyLjAyMyAwIDMuNjkxLS41MDkgNS4wNDQtMS4yNCIvPjxwYXRoIGQ9Ik0yMS45MzcgMTJzLTIuNzAyIDYuNDUzLTkuOTA2IDYuNDUzUzIuMTI1IDEyIDIuMTI1IDEyczIuNzAyLTYuNDUzIDkuOTA2LTYuNDUzUzIxLjkzNiAxMiAyMS45MzYgMTJaIi8+PGNpcmNsZSBjeD0iMTIuMDMxIiBjeT0iMTIiIHI9IjMuNSIvPjwvZz48L3N2Zz4=";
export { SvgEyeBig as ReactComponent };